
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonSearchbar,
  IonSpinner,
  toastController,
  IonInfiniteScroll,
  IonInfiniteScrollContent
} from '@ionic/vue';
import axios from 'axios';
import { defineComponent, ref } from 'vue';
import inseratCard from '../../components/inseratCard.vue';

export default defineComponent({
  name: 'CategoryShowAll',
  data () {
    return {
      category: null,
      inserats: [],
      totalInserats: 0,

      showResultCount: true,
      searchInput: "",
      isLoading: false,
      isLoadingCategory: false,
      submittedSearch: false,
      page: 1,
    }
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonSearchbar,
    IonSpinner,
    inseratCard,
    IonInfiniteScroll,
    IonInfiniteScrollContent
  },
  created() {



    this.isLoading = true;
    axios.get(process.env.VUE_APP_API_URL + '/inserats?category.uuid=' + this.$route.params.id)
        .then(response => {
          this.inserats = response.data["hydra:member"];
          this.totalInserats = response.data["hydra:totalItems"];
        }).finally(() => {
          this.isLoading = false;
        });

    this.isLoadingCategory = true;
    axios.get(process.env.VUE_APP_API_URL + '/categories/' + this.$route.params.id)
        .then(response => {
          this.category = response.data;
        }).finally(() => {
      this.isLoadingCategory = false;
    });
  },
  methods: {
    loadMoreInserats (ev) {
      setTimeout(() => {

        // check if there are more than 30 items
        if (this.totalInserats > 30){
          // load inserats from next page
          this.page += 1;

          let apiUrl = process.env.VUE_APP_API_URL + '/inserats?page='+this.page+'&category='+ this.$route.params.id;

          // check if search filter is applied
          if (!this.showResultCount && this.removeWhitespaces(this.searchInput) !== ""){
            // add search filter
            apiUrl += '&title=' + this.removeWhitespaces(this.searchInput);
          }

          axios.get(apiUrl)
              .then(response => {

                response.data["hydra:member"].forEach(element => {
                  this.inserats.push(element);
                });

              }).finally(() => {
            ev.target.complete();
            ev.target.disabled = true;
          });

        } else {
          this.openToast('Keine weiteren Inserate gefunden.', 2000);
          ev.target.complete();
          ev.target.disabled = true;
        }

      }, 500);
    },
    search() {

      if (this.removeWhitespaces(this.searchInput) == ""){
          this.openToast('Eingabe darf nicht leer sein.', 2000);
      } else {
        this.isLoading = true;
        this.submittedSearch = true;

        axios.get(process.env.VUE_APP_API_URL + '/inserats?category=' + this.$route.params.id + '&title=' + this.removeWhitespaces(this.searchInput))
            .then(response => {
              this.inserats = response.data["hydra:member"];
              this.totalInserats = response.data["hydra:totalItems"];
            })
            .finally(() => {

              if (this.totalInserats == 0){
                this.isLoading = true;
                axios.get(process.env.VUE_APP_API_URL + '/inserats?category=' + this.$route.params.id + '&createdBy.username=' + this.removeWhitespaces(this.searchInput))
                    .then(response => {
                      this.inserats = response.data["hydra:member"];
                      this.totalInserats = response.data["hydra:totalItems"];
                    })
                    .finally(() => {
                      this.isLoading = false;
                    })
              } else {
                this.isLoading = false;
              }
            })
      }

    },
    removeWhitespaces(str){
      return str.trim();
    },
    showSearch() {
      // hide results count
      this.showResultCount = false;
    },
    hideSearch(){
      this.searchInput = "";
      this.showResultCount = true;
      this.submittedSearch = false;

      this.isLoading = true;
      axios.get(process.env.VUE_APP_API_URL + '/inserats?category='+ this.$route.params.id)
          .then(response => {
            this.inserats = response.data["hydra:member"];
            this.totalInserats = response.data["hydra:totalItems"];
          }).finally(() => {
            this.isLoading = false;
          });

    },
    async openToast(message: string, duration: number, color: string) {

      if (!color){
        color = "primary";
      }

      const toast = await toastController
          .create({
            message: message,
            duration: duration
          })
      return toast.present();
    },
  }
});

